// Split out of src/components/SettingsTab.jsx (docs/FILE_SPLIT_RUN1_SPEC.md, move-only).
// SettingsTab.jsx re-exports everything it exported before, so existing imports keep working.

import { getDeviceOwnerAdultId, getActiveAdultId, getHouseholdCode } from "../../lib/api.js";
import { actingAdultHere } from "../../lib/adults.js";

// LB-343 — who is doing this. One helper for the whole file: several of the cards below are
// sub-components that never received `code` as a prop, and threading it to each of them is a
// prop drill whose only purpose is to name a person we already know.
const actor = (s) => actingAdultHere(s, getActiveAdultId, getDeviceOwnerAdultId, getHouseholdCode());

// Drives the small red dot on a menu row — a real, meaningful signal rather than a
// decoration, so it's worth checking against `state` here rather than hardcoding it into
// the category list above. Add a new condition per category as new things become worth
// flagging (e.g. a future "currency changed but interest rate never set").
// Same red dot as the Settings menu row, reused at field level. The menu-level dot on
// "Household" or "Security" tells a parent *something* in there needs attention but not
// what — this is the pointer that finishes the job once they've drilled in, landing on the
// exact field the top-level condition was actually about.
function AttentionDot() {
  return <span className="inline-block w-2 h-2 rounded-full bg-rose-500 ml-1.5 align-middle flex-shrink-0" aria-label="Needs attention" />;
}

export { actor, AttentionDot };
